'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _rafThrottle = require('../../../common/utils/lib/rafThrottle');

var _rafThrottle2 = _interopRequireDefault(_rafThrottle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Utils


exports.default = function (DecoratedComponent) {
    var renderThrottleDecorator = function (_React$Component) {
        _inherits(renderThrottleDecorator, _React$Component);

        function renderThrottleDecorator(props) {
            _classCallCheck(this, renderThrottleDecorator);

            var _this = _possibleConstructorReturn(this, (renderThrottleDecorator.__proto__ || Object.getPrototypeOf(renderThrottleDecorator)).call(this, props));

            _this.throttledSetState = (0, _rafThrottle2.default)(_this.setState.bind(_this));

            _this.state = {};
            return _this;
        }

        _createClass(renderThrottleDecorator, [{
            key: 'componentWillMount',
            value: function componentWillMount() {
                this.setState({ props: this.props });
            }
        }, {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                this.throttledSetState({ props: nextProps });
            }
        }, {
            key: 'shouldComponentUpdate',
            value: function shouldComponentUpdate(nextProps, nextState) {
                return this.state !== nextState;
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.throttledSetState.cancel();
            }
        }, {
            key: 'render',
            value: function render() {
                return _react2.default.createElement(DecoratedComponent, this.state.props);
            }
        }]);

        return renderThrottleDecorator;
    }(_react2.default.Component);

    renderThrottleDecorator.propTypes = {};

    return renderThrottleDecorator;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/milanoteRecompose/renderThrottleDecorator.js
// module id = 763
// module chunks = 0